import { merge } from '../utils';
import { Flex, FlexProps } from './Flex';
import { Separator } from './Separator';

export type CardProps = {
  separator?: boolean;
};

export const Card = ({ children, className, ...rest }: FlexProps) => {
  return (
    <Flex col {...rest} className={merge('group/card rounded-md border-1 border-gray-200 bg-white', className)}>
      {children}
    </Flex>
  );
};

export const CardHeader = ({ children, className, separator, ...rest }: FlexProps & CardProps) => {
  return (
    <>
      <Flex {...rest} className={merge('px-md py-md items-start', className)}>
        {children}
      </Flex>

      {separator && <Separator orientation="horizontal" />}
    </>
  );
};

export const CardBody = ({ children, className, ...rest }: FlexProps) => {
  return (
    <Flex {...rest} className={merge('px-md py-md bg-gray-25', className)}>
      {children}
    </Flex>
  );
};

export const CardFooter = ({ children, separator, className, ...rest }: FlexProps & CardProps) => {
  return (
    <>
      {separator && <Separator orientation="horizontal" />}

      <Flex {...rest} className={merge('px-md py-md', className)}>
        {children}
      </Flex>
    </>
  );
};
